import * as core from "core/Legacy/legacy";

export { core };
export default core;
